// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SiteInfo_wrapper__3unWM","container":"SiteInfo_container__20K4o"};